<template>
  <div class="main-box">
    <div class="content">
      <div class="title-box flex-row">
        <span class="tit">设备列表</span>

      </div>
      <div class="deviceTable">
        <el-table :data="tableData" stripe>

          <!--        <el-table-column align="center" label="订单名称" prop="orderNo">-->
          <!--          <template scope="{row}">-->
          <!--            <span>{{-->
          <!--              row.vArray == 2 ? row.orderNo+ "合并订单" : row.orderNo-->
          <!--            }}</span>-->
          <!--            <span v-if="row.status == 60">(续)</span>-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <el-table-column align="center" label="订单编号" prop="number">
          </el-table-column>
          <el-table-column
              align="center"
              label="下单人名称"
              prop="createUsername"
          ></el-table-column>
          <el-table-column
              align="center"
              label="电话"
              prop="phone"
          ></el-table-column>
          <el-table-column label="下单时间" align="center">
            <template slot-scope="scope">
              {{ formatMomentTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="留言" prop="remark">
          </el-table-column>
          <!--          <el-table-column label="创建时间" align="center" prop="createTime" />-->

          <!--        <el-table-column align="center" label="租赁时长" prop="name">-->
          <!--          <template scope="{row}">-->
          <!--            <div class="time-line">-->
          <!--              <div class="count">-->
          <!--                {{ row.orderPro && row.orderPro.duration }}月-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <!--        <el-table-column-->
          <!--          align="center"-->
          <!--          label="订单价格"-->
          <!--          prop="advance"-->
          <!--        ></el-table-column>-->
          <!--        <el-table-column align="center" label="当前状态" prop="desc">-->
          <!--          <template slot-scope="scope">-->
          <!--              {{scope.row.orderSatus == 0 ? '未确认提交': scope.row.orderSatus == 1 ? '待厂商确认' : scope.row.orderSatus == 2 ? '待平台签约'-->
          <!--              : scope.row.orderSatus == 3 ? '待客户支付租金' : scope.row.orderSatus == 24 ? '待厂商支付服务费'-->
          <!--                  : scope.row.orderSatus == 34 ? '待平台确认服务费': scope.row.orderSatus == 5 ? '待厂商安装验收'-->
          <!--                      : scope.row.orderSatus == 6 ? '待客户用电完成' : scope.row.orderSatus == 7 ? '已完成'-->
          <!--                          : scope.row.orderSatus == 8 ? '已完成(已评价)' : scope.row.orderSatus == 70 ? '中止订单' : '其他'}}-->
          <!--          </template>-->
          <!--        </el-table-column>-->

        </el-table>

      </div>
      <div class="list">
        <!--				<div class="item" v-for="(item,index) in list.archiveList" :key="index">-->

        <div class="device-list" v-for="(good,ind) in list.orderArchiveList" :key="ind">
          <div class="devive-item flex-row">
            <div class="info flex-row">
              <div class="img" style="display: flex;align-items: center;">

<!--                <img :src="$imgUrl + good.archiveImg"/>-->
                <img :src="good.archive.pictureUrl ? $imgUrl + good.archive.pictureUrl : require('../../assets/image/login/logo.png')" />

              </div>
              <div class="text" v-if="good.archive.serviceDictValue == 0">
                <p>{{good.archive.name}}</p>
                <p>设备容量：{{getRl('volume_kva',good.archive.volumeDictValue)}}</p>
<!--                <p>输出电压：{{ getDy('voltage_kv',good.archive.voltageDictValue)}}</p>-->
              </div>
              <div class="text" v-else>
                <p>{{good.archive.name}}</p>
                <p style="width: 186px">设备类型：{{ getSb('lighting_type',good.archive.lightingTypeValue)}}</p>
              </div>

            </div>
            <div>
              <div class="type" v-if="good.archive.serviceDictValue == 0">保电类</div>
              <div class="type" v-if="good.archive.serviceDictValue == 1">照明类</div>
              <div class="type" v-if="good.archive.serviceDictValue == 2">其他类</div>
            </div>
            <!--							<div class="type">{{good.serviceType == 0 ? '成套设备租赁' : '保电设备租赁'}}</div>-->

            <el-input-number v-model="good.number" disabled @change="updataNum(good)" :min="1" :max="100"
                             label="数量"></el-input-number>
          </div>

        </div>
        <!--					</div>-->
      </div>
    </div>


  </div>
</template>

<script>
import {
  carListApi,
  getById,
  deleteGoodApi,
  applicationShop, addEquipmentApi,
  swapUser, getDicts
} from '../../http/api/ordinary.js'

import fa from "element-ui/src/locale/lang/fa";
import {phoneAndCodeLoginApi, sendCodeApi} from "@/http/api/user";
import {getDictByType} from "@/utils/dictUtils";
import moment from "moment/moment";

export default {
  data() {
    return {
      list: [],
      id: '',
      //字典
      dicts:{},
      dictsVolume:{},
      dictsLight:{},
      tableData:[],
    };
  },
  created() {
    this.id = this.$route.query.orderId

    this.getList()
    this.getDict('voltage_kv')
    this.getVolume('volume_kva')
    this.getLight('lighting_type')
  },
  methods: {
    formatMomentTime(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },

    async getDict(type) {
      // this.dicts[type] = await getDictByType('voltage_kv')

      this.dicts[type] = await getDictByType(type)
      console.log(this.dicts[type])
    },
    async getVolume(type){
      this.dictsVolume[type] = await getDictByType(type)
    },
    async getLight(type){
      this.dictsLight[type] = await getDictByType(type)
    },
    getDy(type,val) {
      try {
        const res = this.dicts[type]

        const matchedItem = res.find(item => item.dictValue == val).dictLabel

        return matchedItem
      } catch (error) {

      }
    },
    getSb(type,val){
      try {
        const res = this.dictsLight[type]
        const matchedItem = res.find(item => item.dictValue == val).dictLabel
        return matchedItem
      } catch (error) {

      }
    },
    getRl(type,val){
      try {
        const res = this.dictsVolume[type]
        const matchedItem = res.find(item => item.dictValue == val).dictLabel
        return matchedItem
      } catch (error) {

      }
    },

    getList() {
      getById(
          this.id
      ).then(response => {
        // for (let arr of res) {
        // 	for (let item of arr.goods) {
        // 		item['check'] = false
        // 	}
        // }
        this.list = response

        this.tableData.push(this.list)
        console.log(this.tableData )
      })
    },
    toDetail(id, type) {

      // this.$router.push({
      // 	path: type == 0 ? '/ordinaryUser/rentDetail' : '/ordinaryUser/emergencyDetail',
      // 	query: {
      // 		id: id,
      // 		changeEq: 0
      // 	}
      // })
      this.$router.push({
        path: '/ordinaryUser/rentDetail',
        query: {
          id: id.archiveId,

        }
      })
    },
    // 移除设备
    deleteGood(id) {
      deleteGoodApi(
          id
      ).then(res => {
        this.$message({
          type: 'success',
          message: '设备移除成功'
        })
        this.getList()
      })
    },
    // 确定服务
    sumbit() {
      if (this.selectedItems.length === 0) {
        this.$message({
          message: '请选择选择设备后再申请服务',
          type: 'warning'
        });
        return
      }
      if (this.selectedItems.length !== 0) {
        var companyName = this.selectedItems[0].archive.customerName
      }
      this.ids = this.selectedItems.map(item => {
        return item.id
      });
      this.selectedItems.forEach(item => {
        if (companyName !== item.archive.customerName) {
          this.$message({
            message: '申请时只能选择同一家公司',
            type: 'warning'
          });
        }
      })

      this.shopShow = true
      this.name = this.$store.state.name
      this.phone = this.$store.state.account

      // applicationShop({
      //
      // })
      // for (let good of this.list) {
      // 	for (let item of good.goods) {
      // 		if (item.check) {
      // 			ids.push(item.goodId)
      // 		}
      // 	}
      // }

      // if (ids.length == 0) {
      // 	return this.$message('请选择设备')
      // }
      // checkOrderApi({
      // 	equipmentIds: ids.join(',')
      // }).then(res => {
      // 	if (res.code == 200) {
      // 		this.$router.push({
      // 			path: '/ordinaryUser/createCarOrder',
      // 			query: {
      // 				ids
      // 			}
      // 		})
      // 	}
      // })
    }
  }
}
</script>

<style scoped lang="less">
.main-box {

  padding: 0.1rem 0;
}

.content {
  width: 15.2rem;
  background: #ffffff;
  border-radius: 0.06rem;
  margin: 0 auto;
}

.title-box {
  line-height: 0.74rem;
  border-bottom: 1px solid #eaeaea;
  justify-content: space-between;
  padding: 0 0.25rem;

  span {
    font-size: 0.14rem;
    color: #434343;
  }

  .tit {
    font-size: 0.18rem;
    color: #000000;
  }
}

.list-header {
  height: 0.5rem;
  font-size: 0.14rem;
  color: #000000;
  justify-content: space-between;
  padding: 0 0.2rem;

  div {
    flex: 1;
    text-align: center;
    line-height: 0.5rem;
  }

  div:nth-of-type(1) {
    min-width: 3.6rem;
  }
}

.checkbox {
  display: flex;
  align-items: center;

  /deep/ .el-checkbox__label {
    font-size: 0.14rem;
  }
}

.list {
  min-height: 600px;
  padding: 0 0.2rem;

  .item {
    margin-bottom: 0.2rem;
  }

  .company {
    padding: 0.1rem 0;
    align-items: center;
    font-size: 0.14rem;

    .c-img {
      width: 0.26rem;
      height: 0.26rem;
      border-radius: 0.04rem;
      margin: 0 0.1rem;
    }
  }

  .device-list {
    background: #f8f8f8;
    border-radius: 0.06rem;
    margin-top: 0.1rem;

    .device-checkall {
      padding: 0 0.36rem;
      height: 0.45rem;
      display: flex;
      align-items: center;
    }

    .devive-item {
      font-size: 0.14rem;
      padding: 0.25rem 0.36rem;
      justify-content: space-between;
      border-top: 1px solid #e9e9e9;
      align-items: center;

      .info {
        width: 330px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 100px;
          height: 100px;
          border-radius: 0.06rem;
        }

        .text {
          width: 200px;
          margin-left: 10px;

          p {
            font-size: 0.14rem;
            color: #4a4a4a;
            line-height: 0.28rem;
          }

          p:nth-of-type(1) {
            font-size: 0.2rem;
            color: #333333;
            font-weight: bold;
            line-height: 0.28rem;
            margin-bottom: 0.1rem;
          }
        }
      }

      .type {

        display: flex;
        align-items: center;
        font-size: 0.14rem;
        color: #000000;
      }

      .price {
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        color: #ff4343;
      }

      .btns {
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        color: #4b4b4b;

        span {
          margin-right: 0.36rem;
          cursor: pointer;
        }
      }
    }
  }
}

.bot {
  justify-content: end;
  align-items: center;
  padding: 20px 40px;

  p {
    font-size: 0.14rem;
    color: #000000;
    line-height: 0.42rem;
    margin-right: 20px;

    span {
      color: #ff6332;
    }
  }
}

.title {
  text-align: center;
  font-size: 20px;
  margin: 20px 0 20px;
}

.message {
  & > div {
    display: flex;
    margin-bottom: 15px;
    align-items: center;

    .box {
      width: 320px;
      margin-left: 10px;
      height: 44px;
      background-color: #f8f8f8;

      border-radius: 6px;
      box-sizing: border-box;
      padding: 10px 0px;
      display: flex;

      .icon {
        width: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #d9d9d9;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .text {
        width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #d9d9d9;
        font-size: 14px;
        color: #9b9b9b;

        &:hover {
          cursor: pointer;
        }
      }

      .el-input {
        flex: 1;

        /deep/ .el-input__inner {
          height: 24px;
          background-color: transparent;
          border-color: transparent;
        }
      }
    }

    span {
      width: 80px;
      text-align: right;
      font-size: 14px;
      margin-left: 130px;
    }

    /deep/ .el-input {
      width: 320px;
      background-color: #f8f8f8;
      margin-left: 10px;
    }

    /deep/ .el-input__inner {
      background-color: #f8f8f8;
    }

    /deep/ .el-textarea {
      width: 320px;
      background-color: #f8f8f8;
      margin-left: 10px;
    }

    /deep/ .el-textarea__inner {
      background-color: #f8f8f8;
    }
  }
}

.custom-footer {
  display: flex;
  justify-content: center;
  gap: 20px; /* 按钮间距 */
}
</style>
